import { useQuery } from '@tanstack/react-query';

import { agentTrpc } from 'src/lib/agent-trpc';
import { useActiveCourse } from 'src/class/class-provider';

import { todayIso } from 'src/sections/makeup/use-class-lesson-dates';

// ----------------------------------------------------------------------

/**
 * `department.overview` for the active school year (epic #566) — the Department page and the
 * header's section switcher share this one cached read.
 */
export function useDepartmentOverview(enabled = true) {
  const { activeSchoolYearId } = useActiveCourse();
  const today = todayIso();
  return useQuery({
    queryKey: ['departmentOverview', activeSchoolYearId ?? null, today],
    enabled: enabled && !!activeSchoolYearId,
    staleTime: 60_000,
    queryFn: () => agentTrpc.department.overview({ schoolYearId: activeSchoolYearId!, today }),
  });
}
